import React from 'react';
import planIcon from '../../../../../../assets/image/subscription/plan-icon.svg';
import Button from '../../../../../../component/ui/Button';
import { format2DigitDate } from '../../../../../../utils/constant';
import { axiosInstanceV2 } from '../../../../../../services/axios';
import { toast } from 'react-toastify';
import { loadRazorpay } from '../../../../../../utils/loadRazorpay';

export default function CurrentPlanComponents({
	currentPlan,
	setIsOpenCancelSubscriptionModal,
	setSubscriptionScreenType,
}) {

	const isFreePlan =
		currentPlan?.is_free || currentPlan?.plan?.key === "free";

	const handleResumeSubscription = async () => {
		try {
			const token = localStorage.getItem('authToken');
			const response = await axiosInstanceV2.post('/subscription/resume', {}, {
				headers: { Authorization: `Bearer ${token}` },
			});

			const result = response.data.data;

			if (result.type === 'resumed') {
				toast.success('Subscription resumed successfully!');
				return;
			}

			if (result.type === 'resubscribed') {
				// need to complete payment for new subscription
				toast.info('Please complete payment to reactivate your subscription');

				// open razorpay checkout
				const razorpayLoaded = await loadRazorpay();
				if (!razorpayLoaded) {
					toast.error('Razorpay SDK failed to load');
					return;
				}
				const options = {
					key: result.razorpay_key_id,
					subscription_id: result.subscription_id,
					name: 'Pharmnex',
					description: `${result.plan_name} - ${result.billing_period}`,
					currency: result.currency ?? 'INR',
					recurring: 1,
					handler: async () => {
						toast.success('Subscription reactivated successfully 🎉');
						// fetchSubscriptionDetails();
					},
					modal: {
						ondismiss: () => toast.info('Payment cancelled'),
					},
					theme: { color: '#3B58FF' },
				};

				const rzp = new window.Razorpay(options);
				rzp.open();
			}

		} catch (error) {
			toast.error(error?.response?.data?.message ?? 'Failed to resume subscription');
		}
	};

	const handleCancelScheduledDowngrade = async () => {
		try {
			const token = localStorage.getItem("authToken");

			await axiosInstanceV2.post(
				"/subscription/cancel-scheduled-downgrade",
				{},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			toast.success("Scheduled downgrade cancelled.");

			window.location.reload();

		} catch (error) {
			console.log(error)
			toast.error(
				error?.response?.data?.message ??
				"Unable to cancel scheduled downgrade."
			);
		}
	};

	return (
		<div style={{ overflow: "auto" }}>
			<div className="fs-3 fw-semibold py-2">Current Subscription</div>
			{currentPlan?.is_downgrade_scheduled && (
				<div
					className="mb-3 rounded-3 p-3"
					style={{
						background: "#EEF6FF",
						border: "1px solid #6EA8FE",
					}}
				>
					<div className="d-flex align-items-center gap-2">
						<span style={{ fontSize: 20 }}>📅</span>
						<div className="fw-semibold">
							Downgrade Scheduled
						</div>
					</div>

					<div className="mt-2 fs-5">
						Your subscription will automatically change to{" "}
						<strong>{currentPlan?.downgrade_plan?.name}</strong> on{" "}
						<strong>{format2DigitDate(currentPlan?.downgrade_at)}</strong>.
					</div>

					<div className="mt-1 fs-5 text-muted">
						You'll continue enjoying your current plan until then.
					</div>
				</div>
			)}
			{currentPlan?.is_scheduled_for_cancellation && (
				<div
					className="mb-3 rounded-3 p-3"
					style={{
						background: "#FFF8E6",
						border: "1px solid #F4C46B",
					}}
				>
					<div className="d-flex align-items-center gap-2">
						<span style={{ fontSize: 20 }}>⚠️</span>
						<div className="fw-semibold text-dark">
							Subscription Scheduled for Cancellation
						</div>
					</div>

					<div className="mt-2 fs-5">
						Your subscription will remain active until{" "}
						<strong>{format2DigitDate(currentPlan.current_end)}</strong>.
					</div>

					<div className="mt-1 fs-5 text-muted">
						Auto-renewal has been turned off, so you won't be charged again.
					</div>

					<hr className="my-3" />

					<div className="fs-5">
						If you'd like to continue using your current plan after{" "}
						<strong>{format2DigitDate(currentPlan.current_end)}</strong>, you can
						purchase a new subscription once your current subscription ends.
					</div>
				</div>
			)}
			<div
				className="d-flex justify-content-between align-items-center rounded-3 p-2"
				style={{
					border: '1px solid rgba(85, 91, 103, 0.15)',
					backgroundColor: 'rgba(252, 252, 252, 1)',
				}}
			>
				<div className="d-flex justify-content-start align-items-center">
					<img
						src={planIcon}
						className="px-2"
						alt="icon"
					/>
					<div className="px-3">
						<div className="d-flex gap-4 align-items-center">
							<div className="fs-4 font-medium">{`${currentPlan?.plan?.name || 'Free Plan'}`}</div>
							<div
								className="p-2 fs-5 font-small rounded-4"
								style={{ backgroundColor: '#F0FFE6', color: '#68C230', width: '50px' }}
							>
								{currentPlan?.status}
							</div>
						</div>
						<div className="fs-5 font-small">Description: {currentPlan?.plan?.description || 'N/A'}</div>
						<div className="fs-5 font-small">
							{
								isFreePlan
									? "No payment subscription"
									: `Subscription Id : ${currentPlan?.razorpay_subscription_id}`
							}
						</div>
					</div>
				</div>
				<div className="subscription-divider"></div>
				<div className="px-3">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-4 font-medium">{'Amount'}</div>
					</div>
					{
						isFreePlan ? (
							<>
								<div className="fs-5 font-small text-success">
									Free Forever
								</div>
								<div className="fs-5 font-small">
									No recurring charges
								</div>
							</>
						) : (
							<>
								<div className="fs-5 font-small">
									₹ {currentPlan?.amount} / {currentPlan?.billing_period}
								</div>

								<div className="fs-5 font-small">
									Billed {currentPlan?.billing_period}
								</div>
							</>
						)
					}
				</div>
				<div className="subscription-divider"></div>
				<div className="px-3">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-4 font-medium">{'Validity'}</div>
					</div>
					<div className="fs-5 font-small">{`${currentPlan?.current_start !== null ? format2DigitDate(currentPlan?.current_start) : ''} - ${currentPlan?.current_end !== null ? format2DigitDate(currentPlan?.current_end) : ''}`}</div>
					{currentPlan?.is_downgrade_scheduled ? (
						<div className="fs-5 font-small text-primary">
							Downgrades on {format2DigitDate(currentPlan.downgrade_at)}
						</div>
					) : currentPlan?.next_billing_date ? (
						<div className="fs-5 font-small">
							Next billing on {format2DigitDate(currentPlan.next_billing_date)}
						</div>
					) : currentPlan?.is_scheduled_for_cancellation ? (
						<div className="fs-5 font-small text-warning">
							Subscription ends on {format2DigitDate(currentPlan.current_end)}
						</div>
					) : null}
				</div>
				<div className="subscription-divider"></div>
				<div className="px-3">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-4 font-medium">{'Status'}</div>
					</div>
					<div
						className="p-2 fs-5 font-small rounded-4"
						style={{
							backgroundColor:
								currentPlan?.is_downgrade_scheduled
									? "#EEF6FF"
									: currentPlan?.is_scheduled_for_cancellation
										? "#FFF4E5"
										: "#F0FFE6",
							color:
								currentPlan?.is_downgrade_scheduled
									? "#0D6EFD"
									: currentPlan?.is_scheduled_for_cancellation
										? "#E67E22"
										: "#68C230",
						}}
					>
						{
							currentPlan?.is_downgrade_scheduled
								? "Downgrade Scheduled"
								: currentPlan?.is_scheduled_for_cancellation
									? "Scheduled for Cancellation"
									: currentPlan?.status
						}
					</div>
					<div className="fs-5 font-small">
						{
							!isFreePlan && (
								<div className="fs-5 font-small">
									Auto Renewal
									<span
										className={`ms-2 fw-semibold ${currentPlan?.auto_renewal
											? "text-success"
											: "text-danger"
											}`}
									>
										{currentPlan?.auto_renewal ? "ON" : "OFF"}
									</span>
								</div>
							)
						}
					</div>
				</div>
				<div className="align-items-center px-5 py-4">
					{
						!isFreePlan && <Button
							type="button"
							className="mt-0 btn-primary fs-5 fw-light add-pro py-1 px-4"
							button="Manage Billing"
							onClick={() => setSubscriptionScreenType("manage-billing")}
						/>
					}
					{
						isFreePlan ? (
							<div
								className="mt-3 fs-5 font-small text-primary cursor-pointer"
								onClick={() => setSubscriptionScreenType("pricing")}
							>
							</div>
						) : currentPlan?.is_downgrade_scheduled ? (
							<div
								className="mt-3 fs-5 font-small text-warning cursor-pointer"
								onClick={handleCancelScheduledDowngrade}
							>
								Undo Downgrade
							</div>
						) : currentPlan?.is_scheduled_for_cancellation ? (
							<div
								className="mt-3 fs-5 font-small text-primary cursor-pointer"
								onClick={handleResumeSubscription}
							>
								Resume Subscription
							</div>
						) : (
							<div
								className="mt-3 fs-5 font-small text-danger cursor-pointer"
								onClick={() => setIsOpenCancelSubscriptionModal(true)}
							>
								Cancel Subscription
							</div>
						)
					}
				</div>
			</div>
		</div>
	);
}
